// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`EventFilter component should render without throwing an error 1`] = `<FilterBreadcrumbs />`;
